// Stored permission only. Runtime activation is a separate release.
export const MAGNET_AGENT_TOOLS = Object.freeze([
  { value: 'none', label: 'Off' },
  { value: 'read', label: 'Read only' },
  { value: 'all', label: 'Open and prefill' },
]);

export function normalizeMagnetAgentTools(value) {
  if (value == null || value === false) return 'none';
  if (value === true) return 'all';
  if (MAGNET_AGENT_TOOLS.some(option => option.value === value)) return value;
  throw new TypeError('Choose Off, Read only, or Open and prefill for AI assistant access.');
}

// Fail closed when reading older or externally authored definitions. Writes stay strict.
export function readMagnetAgentTools(value) {
  try { return normalizeMagnetAgentTools(value); }
  catch { return 'none'; }
}

// Public telemetry is a client-reported hint, never an authentication decision.
// Omit the default to preserve historical payloads, digests and reporting output.
export const magnetInteractionSource = value => value === 'agent' ? { source: 'agent' } : {};
export const magnetInteractionTags = value => value === 'agent'
  ? [{ tag: 'm5m_agent_assisted', value: true }] : [];
